import React from 'react';
import { FILTER_CATEGORIES } from '../../utils/constants';

const CategoryFilter = ({ selectedCategory, onFilterChange }) => {
  return (
    <div className="flex flex-wrap gap-3 mb-8">
      {FILTER_CATEGORIES.map(category => (
        <button
          key={category.id}
          onClick={() => onFilterChange(category.id)}
          className={`px-6 py-2.5 rounded-full font-medium transition-all transform hover:scale-105 ${
            selectedCategory === category.id
              ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg'
              : 'bg-slate-800 text-slate-300 hover:bg-slate-700'
          }`}
        >
          {category.name}
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;
